module.exports = __webpack_public_path__ + "img/FAQ.0e9ca0b3.svg";